var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.elements.showMenu)?_c('MainMenu'):_vm._e(),_c('ClientMenu'),_c('main',{staticClass:"default-transition",staticStyle:{"opacity":"1"}},[(_vm.configloaded)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }